




















import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { Endpoints } from '@/ts/store/Constants';

@Component({})

export default class SendWelcomeEmailsCard extends Vue {

    public responseMessage = null;
    public sendingWelcomeMails = false;
    public sendWelcomeMailsObject: any = {
        
        onlyNotLoggedIn: false,
    };

    public created() {
        axios.get(Endpoints.Admin.Corporations.CURRENT_CORPORATION)
            .then((response) => {
                this.sendWelcomeMailsObject.corporationId = response.data.id;
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public resetOnlyNotLoggedIn() {
        this.sendWelcomeMailsObject.onlyNotLoggedIn = false;
    }

    public sendWelcomeMails() {
        axios.post(Endpoints.Neckbeard.SEND_WELCOME_MAILS, {corporationId: this.sendWelcomeMailsObject.corporationId, onlyNotLoggedIn: this.sendWelcomeMailsObject.onlyNotLoggedIn})
            .then((response) => {
                console.log(response);
                this.resetOnlyNotLoggedIn();
                this.responseMessage = 'Welcome emails send.';
            })
            .catch((error) => {
                console.log(error);
                this.responseMessage = error.message;
                this.resetOnlyNotLoggedIn();
            });
    }
}
